module.exports = __webpack_public_path__ + "img/sb.c514d29c.svg";